import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'relative',
    children: [
      {
        path: '',
        loader: protectedLoader('RELATIVES', 'VIEW_RELATIVES'),
        async lazy() {
          const {RelativeListPage} = await import('./pages/RelativeListPage');
          return {element: <RelativeListPage />};
        },
      },
      {
        path: ':id',
        loader: protectedLoader('RELATIVES', 'VIEW_RELATIVE'),
        async lazy() {
          const {RelativeViewPage} = await import('./pages/RelativeViewPage');
          return {element: <RelativeViewPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [] as MenuItemElement[];
